import http from "./httpService";

const Urlapi = "https://api-mobileapp.advanceagro.net";
export async function getWeightlist(
  start = "",
  end = "",
  branchid = "",
  typeid = "0",
  search = "",
  pageSize = 1000,
  pageNumber = 1
) {
  // console.log('cusid=',search);
  return http.get(
    "/JAWIS/Weightlist?startdate=" +
      start +
      "&enddate=" +
      end +
      "&branchid=" +
      branchid +
      "&typeid=" +
      typeid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&search=" +
      search
  );
}


export async function WoodReceiveWeeklyAA() {
  return http.get("/ips/WoodReceiveWeekly?BranchID=AA");
}
export async function ReportWoodChip(
  reportcode = "R01",
  startdate = "",
  enddate = "",
  storeId
) {
  return http.get(
    "/report/ReportWoodChip?ReportCode=" +
      reportcode +
      "&StartDate=" +
      startdate +
      "&EndDate=" +
      enddate +
      "&StorageID=" +
      storeId
  );
}
export async function getCCP(
  startdate = "",
  enddate = "",
  pageSize = 1000,
  pageNumber = 1
) {
  return http.get(
    "/jawis/getresultReceive?startdate=" +
      startdate +
      "&enddate=" +
      enddate +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}
export async function getCustomerList(
  id = "",
  name = "",
  pageSize = 1000,
  pageNumber = 1
) {
  return http.get(
    "/wms/getCustomerList?BranchID=" +
      id +
      "&name=" +
      name +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}
export async function getDrivenlist(
  id = "",
  name = "",
  pageSize = 1000,
  pageNumber = 1
) {
  return http.get(
    "/wms/getDrivenlist?id=" +
      id +
      "&name=" +
      name +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}
export async function getEditresult(id = 0) {
  return http.get("/jawis/getEditresult?id=" + id);
}
export async function getCustomerType(id) {
  return http.get("/wms/getCustomerType?BranchID=" + id);
}
export async function getCustomer(id) {
  return http.get("/wms/getCustomer?BranchID=" + id);
}
export async function getSourceProduct(id) {
  return http.get("/wms/getProductsource?id=" + id);
}

export async function GetCompany(id, pid) {
  return http.get("/wms/GetCompanyData?branchid=" + id + "&id=" + pid);
}
export async function getGroupTruck(id) {
  return http.get("/wms/getGroupTruck?branchid=" + id);
}
export async function getDriven(id = 0) {
  return http.get("/wms/getDriven?id=" + id);
}
export async function getQueueWoodchip(startdate, id) {
  return http.get(
    "/wms/getQueueWoodchip?startdate=" + startdate + "&prodid=" + id
  );
}
export async function GetBranch() {
  return http.get("/wms/GetBranch");
}
export async function SaveCCP(doc) {
  return http.post("/jawis/SaveCCP", doc);
}
export async function getRegisterlist(
  start = "",
  end = "",
  branchid = "",
  cusid = "0",
  search = "",
  pageSize = 1000,
  pageNumber = 1
) {
  // console.log('cusid=',pageNumber);
  return http.get(
    "/wms/RegisterCoalList?startdate=" +
      start +
      "&enddate=" +
      end +
      "&branchid=" +
      branchid +
      "&cusid=" +
      cusid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&search=" +
      search
  );
}
export async function Weightlist(
  start = "",
  end = "",
  branchid = "",
  cusid = "0",
  search = "",
  pageSize = 1000,
  pageNumber = 1
) {
  // console.log('cusid=',pageNumber);
  return http.get(
    "/wms/getWeightlist?startdate=" +
      start +
      "&enddate=" +
      end +
      "&branchid=" +
      branchid +
      "&typeid=" +
      cusid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&search=" +
      search
  );
}
export async function getPrivilege() {
  return http.get("/wms/getPrivilege");
}

export async function getSumaryRegister(start = "", end = "", id) {
  // console.log(start,id,end);
  return http.get(
    "/wms/getSumaryRegister?id=" +
      id +
      "&StartDate=" +
      start +
      "&EndDate=" +
      end
  );
}
export async function getMonitorECE(id, startDate) {
  return http.get(
    "/wms/getMonitorECE?branchid=" + id + "&startdate=" + startDate
  );
}

export async function getregister(webid, id) {
  return http.get("/wms/WebRegisterEdit?branchid=" + id + "&webid=" + webid);
}
export async function weightdetail(id) {
  return http.get("/wms/weightdetail?weightno=" + id);
}
export async function weightmonitor(id, startDate) {
  return http.get(
    "/wms/getweightMonitor?startdate=" + startDate + "&productid=" + id
  );
}
export async function weightperhour(id, startDate) {
  return http.get(
    "/wms/getweightperhour?startdate=" + startDate + "&branchid=" + id
  );
}
export async function queuetdetail(id, branchid) {
  return http.get("/wms/queuedetail?queueid=" + id + "&branchid=" + branchid);
}
export async function gettotalBooking(id, startDate, branchid) {
  return http.get(
    "/wms/gettotalBooking?startdate=" +
      startDate +
      "&prodid=" +
      id +
      "&branchid=" +
      branchid
  );
}
export async function getReport(id, startDate, endDate, branchid,pageSize,pageNumber) {
  return http.get(
    "/wms/getReport?reportcode=" +
      id +
      "&startdate=" +
      startDate +
      "&enddate=" +
      endDate +
      "&branchid=" +
      branchid + "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber 
  );
}
export async function getTreetype( branchid) {
  return http.get(
    "/wms/getTreeType?branchid=" +
      branchid 
  );
}export async function getCustomerIDWeb( branchid) {
  return http.get(
    "/wms/CustomerIDWeb?branchid=" +
      branchid 
  );
}
export async function GetprivilegePage(page = "", id) {
  //wms/getWoodchipSumary?startdate=2021-02-23&branchid=520&id=0
  return http.get("/wms/GetprivilegePage?Page=" + page + "&branchid=" + id);
}
export async function getWoodchipSumary( branchid, startDate,id) {
  return http.get(
    "/wms/getWoodchipSumary?startdate=" + startDate + "&branchid=" + branchid +"&id="+id
  );
}
export async function getMemulist( branchid) {
  return http.get(
    Urlapi+ "/wms/menu/" + branchid 
  );
}
export async function dowLoadExcel( startDate, endDate, branchid,type="",search="") {
  return http.get(
    Urlapi + "/download/toexcelfacmaster?startdate=" +
    startDate +
    "&enddate=" +
    endDate +
    "&branchid=" +
    branchid +"&type="+ type +"&search="+ search ,{responseType: 'blob'}
  );
}

export default {
  getWeightlist,getTreetype,
  WoodReceiveWeeklyAA,
  ReportWoodChip,
  getCCP,
  getEditresult,
  SaveCCP,
  getCustomerType,
  getCustomer,
  getCustomerList,
  getDrivenlist,
  getSourceProduct,
  GetCompany,
  getGroupTruck,
  getDriven,
  GetBranch,
  getPrivilege,
  getregister,
  getSumaryRegister,
  getMonitorECE,
  weightdetail,
  weightmonitor,
  weightperhour,
  getQueueWoodchip,
  queuetdetail,
  gettotalBooking,
  getReport,getCustomerIDWeb,GetprivilegePage,Weightlist,getWoodchipSumary,getMemulist,dowLoadExcel
};
